import { useRef, useEffect } from 'react';

function useIsChanged(deps) {
  const isChanged = useRef(false);

  useEffect(() => {
    return () => (isChanged.current = true);
  }, deps || []);

  return isChanged;
}

export default useIsChanged;
